import { TwilioTaskStatus } from "@/common/enum";

export class TwilioTaskModel {
  assignedWorkerName!: string;
  assignedWorkerSid!: string;
  attributes!: object;
  sid!: string;
  status!: TwilioTaskStatus;
  createdDate!: Date;
  timeSinceCreated!: number;
  priority!: number;
}
